import styled from 'styled-components';
import { gray, multiply, spacer, mediaBreakpointUp, fontStyle } from '@whitelabel/helpers/style';
import { StyledRichTextBlock, StyledSection as StyledSectionBase } from '@whitelabel/component-library';

export const StyledDisclaimer = styled.div`
  padding: ${multiply(spacer, 1.5)} 0;

  ${mediaBreakpointUp('lg')`
    padding: ${multiply(spacer, 4)} 0;
  `}

  color: ${gray(600)};
  background: ${gray(200)};

  ${StyledSectionBase} {
    margin-bottom: 0;
  }

  ${StyledRichTextBlock} {
    *:last-child {
      margin-bottom: 0;
    }
  }

  p {
    ${fontStyle('disclaimer')}
  }
`;
